import type { ExtendedShockwaveViewT } from "@/types/database/events";
import type { ExtendedEventViewT } from "@/types/database/events";

export default function useExtractShockwave(
    event: ExtendedEventViewT | undefined,
    shockwaveId: string,
): ExtendedShockwaveViewT | undefined {
    // Find the shockwave with the matching ID
    const shockwave = event?.shockwaves_view?.find(
        (shockwave) => shockwave.shockwave_id === shockwaveId,
    );

    // Return the found shockwave or undefined
    return shockwave;
}

export function extractShockwave(
    event: ExtendedEventViewT | undefined,
    shockwaveId: string,
): ExtendedShockwaveViewT | undefined {
    const shockwave = event?.shockwaves_view?.find(
        (shockwave) => shockwave.shockwave_id === shockwaveId,
    );
    return shockwave;
}
